// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"21":"133fc7ed","136":"c44bb0d1","244":"7de463c3","300":"c62910e6","495":"133fc7ed","771":"e939514d","848":"63573f99","857":"579814ec","879":"3c73a568"}[chunkId] + ".chunk.css";
};